import React, { createContext, useContext, useState } from 'react';

import { ILanguageContext, IProviderProps } from '../@types/ContextProviderRelated';

const languageContextDefaultValues: ILanguageContext = {
    locale: '',
    setLocale: () => {}
};

const LanguageContext = createContext<ILanguageContext>(languageContextDefaultValues);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }: IProviderProps): JSX.Element => {
    // Supported languages
    const supportedLanguages = ['en', 'de', 'it', 'fr', 'es', 'pl', 'cs', 'nl', 'ja', 'tr', 'pt', 'ro', 'ru', 'sr', 'hr' ];

    // Determine the initial language
    const browserLanguage = navigator.language.split('-')[0]; // Extract language code
    const initialLanguage = supportedLanguages.includes(browserLanguage) ? browserLanguage : 'de';

    const [locale, setLocale] = useState<string>(initialLanguage);

    return (
        <LanguageContext.Provider value={{
            locale,
            setLocale
        }}>
            {children}
        </LanguageContext.Provider>
    );
};
